import Vue from 'vue'

/**
 * Global mixins
 */
Vue.mixin({
  methods: {
    /**
     * Entitlements can checker
     *
     * @param  {{ [key]: String|String[] }} entitlements
     * @param  {Boolean} throwError
     *
     * @return {Boolean|Unauthorized}
     */
    $can (...options) {
      return this.$store.getters['auth/entitlements'].can(...options)
    },
    /**
     * Entitlements any can checker
     *
     * @param  {{ [key]: String|String[] }} entitlements
     * @param  {Boolean} throwError
     *
     * @return {Boolean|Unauthorized}
     */
    $anyCan (...options) {
      return this.$store.getters['auth/entitlements'].anyCan(...options)
    },
    /**
     * Filter array of objects by can property
     *
     * @param {Object} item
     *
     * @return {Boolean}
     */
    $filterByEntitlements (items) {
      return this.$store.getters['auth/entitlements'].filterByEntitlements(items)
    },
    /**
     * Get all keys that passed can entitlements as an array
     *
     * @param {Object} checks
     *
     * @return {Boolean}
     */
    $getPassed (checks) {
      return this.$store.getters['auth/entitlements'].getPassed(checks)
    },
    /**
     * Get all keys that passed anyCan entitlements as an array
     *
     * @param {Object} checks
     *
     * @return {Boolean}
     */
    $getAnyPassed (checks) {
      return this.$store.getters['auth/entitlements'].getAnyPassed(checks)
    },
    /**
     * Goes to the account details
     * @param {String} userId userId to go to
     */
    $goUserDetails (userId) {
      this.$router.push('/accounts/details/' + userId)
    },
    /**
     * Goes to the construct details
     * @param {String} constructId constructId to go to
     */
    $goConstructProfile (constructId) {
      this.$router.push('/bcm/constructs/details/' + constructId)
    },
    /**
     * Goes to the task details
     * @param {String} taskId taskId to go to
     */
    $goTaskProfile (taskId) {
      this.$router.push('/bcm/tasks/details/' + taskId)
    },
    /**
     * Goes to the item details
     * @param {String} itemId itemId to go to
     */
    $goItemProfile (itemId) {
      this.$router.push('/bcm/items/details/' + itemId)
    }

  }
})
